import axios from '../../../../api/axios';
import React,{useState,useEffect} from 'react'
import Formulaire from '../../../ModelesPages/Modele1/FormulaireCours'
import Swal from 'sweetalert2';
import {useParams,useNavigate} from 'react-router-dom'

function Update(){

    const [Count,setCount]=useState(0);
    const {id}=useParams()
    const navigate=useNavigate()
    const [nom,setNom]=useState("");

    useEffect(()=>{
        HanleRequest()
    },[])
    function handleMouse(e){

        e.target.textContent="Bonjour"
    }
    function handleMouseleave(e){
        e.target.textContent="Soumettre"
    }
    function handlekeyUpgain(e){
    
        const elementss=e.nextElementSibling;
      
    }
    function handleclick(){
        alert('You have clicked me')
    }
    const HanleRequest=async(e)=>{
        await axios.get(`api/Cours/${id}`).then((res)=>{
            setNom(res.data.items.nom)
            console.log(res)
        }).catch((err)=>{
            console.log(err)
        })
    }
    function confirmSave(e){
        e.preventDefault()
        if(nom !=""){
        Swal.fire({
            title:'Demande de confirmation',
            text:'Voulez-vous vraiment modifier ce cours ?',
            icon:'question',
            showCancelButton:true,
            showConfirmButton:true,
            confirmButtonText:'Confirmer',
        }).then((resultat)=>{
            if(resultat.isConfirmed){
                HandleSubmit()
            }
        })  
        }
        else{
            Swal.fire({
                title:'Erreur de soumission',
                text:'Veuillez d\'abord entrer le nom du cours',
                icon:'warning'
            })
        }
    }
    const HandleSubmit=async (e)=>{
       
                await axios.put(`api/Cours/${id}`,{nom:nom.toLowerCase()}).then((res)=>{
                    setNom("")
                    if(res.data.status_code===200){
                        Swal.fire({
                            title:'Message de confirmation',
                            text:'Le cours a été modifié avec succès',
                            icon:'success',
                            
                        }).then((resultat)=>{
                            navigate('/cours')
                        })

                    }
                    else{
                        Swal.fire({
                            title:'Message d\'erreur',
                            text:'Une erreur est survenue, réessayer ultérieurement',
                            icon:'error'
                            
                        })
                    }
                    console.log(res)
                     
                }).catch((err)=>{
                        document.getElementById("erreur").innerHTML=err
                        
                        
                })
    }
    return(
    <>
    <Formulaire title="Formulaire d'inscription" onclick={handleclick} confirmSave={confirmSave} setNom={setNom} handlekeyUpgain={handlekeyUpgain}  nom={nom}  handleMouse={handleMouse} Count={Count} setCount={setCount} handleMouseleave={handleMouseleave} HandleSubmit={HandleSubmit}  >
    <div className="w-full md:w-1/1 px-3  md:mb-0">
       
    <div id="resultat" className="block text-red-700"></div>
    <div id="erreur" className="block text-red-500"></div>
    </div>
    </Formulaire>
    </>
    )
}
export default Update